import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Participate from '@components/lpc/Pot/AmountModule/Participate/Participate';
import { poolContributionType, potType } from '@propTypes/potTypes';

import css from './FirstParticipation.module.scss';

type FirstParticipationProps = {
    potRef: string;
    poolContribution: poolContributionType;
    personRole: string;
    pot: potType;
    setOpenParticipate: (boolean) => void;
};

const FirstParticipation = ({
    potRef,
    poolContribution,
    personRole,
    pot,
    setOpenParticipate,
}: FirstParticipationProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    return (
        <div className={css.first}>
            <h5>{t('activity.first-participation-title')}</h5>
            <div className={css.participate}>
                <Participate
                    isUnderlinedTextParticipate
                    personRole={personRole}
                    commissionType={pot.commissionType}
                    customCta={css.participate__cta}
                    potRef={potRef}
                    isFrozen={pot.isFrozenAccount}
                    poolContribution={poolContribution}
                    setOpenParticipate={(value) => setOpenParticipate(value)}
                />
            </div>
        </div>
    );
};

export default FirstParticipation;
